import React from 'react';
import { useInView } from './useInView';
import './About.css';

export default function About() {
  const [ref, visible] = useInView();

  return (
    <section className="section" id="about">
      <div ref={ref} className={`about-grid fade-in${visible ? ' visible' : ''}`}>
        <div className="about-left">
          <p className="section-label">About</p>
          <h2 className="section-title" style={{ marginBottom: 0 }}>Crafting digital<br />experiences that matter.</h2>
        </div>
        <div className="about-right">
          <p className="about-text">
            I'm a Full Stack Java Developer who thrives at the intersection of clean code and compelling interfaces. My toolkit spans Java 17, Spring Boot on the backend, and React.js on the frontend — giving me full ownership of the stack.
          </p>
          <p className="about-text">
            I care deeply about fundamentals: solid Data Structures, normalized databases, secure auth patterns, and maintainable architecture. Whether it's an expense tracker or a product catalog, I build with scalability and readability in mind.
          </p>
          <div className="about-chips">
            {['Java 17', 'Spring Boot', 'React.js', 'MySQL', 'JWT Auth', 'REST APIs', 'Agile'].map(t => (
              <span key={t} className="chip">{t}</span>
            ))}
          </div>
          <div className="about-edu">
            <div className="edu-icon">🎓</div>
            <div>
              <div className="edu-degree">B.Tech — Computer Science & Engineering</div>
              <div className="edu-school">Sandip University, Nashik</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
